<script setup>
import { ref, computed } from "vue";
import db from "../main.js"; //追加
import { collection, query, where, getDocs } from "firebase/firestore";
import VendorPictures from "/src/components/molecules/VendorPictures.vue";
import LiveSchedule from "/src/components/molecules/LiveSchedule.vue";
import TheCarousel from "/src/components/molecules/TheCarousel.vue";
// import BeginnersButton from "/src/components/atoms/BeginnersButton.vue";
// import CrowdfundingButton from "/src/components/atoms/CrowdfundingButton.vue";

//イベントデータ
const productsData = ref([]);
const getProductsData = async () => {
  // クエリオブジェクトを作成
  const q = query(collection(db, "Goods_products"), where("eventcategory", "==", "vtuber"));

  // クエリに基づいてドキュメントを取得
  const querySnapshot = await getDocs(q);

  // 取得したドキュメントのデータをproductsDataに格納
  productsData.value = querySnapshot.docs.map((doc) => doc.data());
};

// この関数を呼び出してデータを取得
getProductsData();

//ライブデータ
const liveData = ref([]);
const getLiveData = async () => {
  console.log("livesss");
  // Goods_liveschedule コレクションから eventcategory が vtuber であるドキュメントをクエリする
  const q = query(collection(db, "Goods_liveshedule"), where("eventcategory", "==", "vtuber"));

  // クエリに基づいてドキュメントを取得
  const querySnapshot = await getDocs(q);

  // 取得したドキュメントのデータを liveData に格納
  const goodsLiveData = querySnapshot.docs.map((doc) => doc.data());

  // 配信クラファンのライブスケジュールを取得
  try {
    // Crowdfunding_projectsを取得してnowstreamingを確認
    const projectsQuery = query(collection(db, "Crowdfunding_projects"));
    const projectsSnapshot = await getDocs(projectsQuery);
    const projectsMap = new Map();
    projectsSnapshot.docs.forEach((doc) => {
      const data = doc.data();
      const projectId = data.projectid || doc.id;
      projectsMap.set(projectId, {
        nowstreaming: data.nowstreaming || false,
        projectTitle: data.projectTitle,
        vendor_ja: data.vendor_ja,
        vendor_image: data.vendor_image,
        iconURL: data.iconURL,
      });
    });

    // eventcategoryでフィルタしてCrowdfunding_livesheduleを取得
    const crowdfundingLiveQuery = query(
      collection(db, "Crowdfunding_liveshedule"),
      where("eventcategory", "==", "vtuber")
    );
    const crowdfundingLiveSnapshot = await getDocs(crowdfundingLiveQuery);

    // 配信クラファンのライブスケジュールを取得し、live_statusを設定
    const crowdfundingLiveData = crowdfundingLiveSnapshot.docs
      .map((doc) => {
        const data = doc.data();
        const projectId = data.projectid;
        const projectData = projectsMap.get(projectId);

        // ステータス判定：各配信枠のlive_statusのみで判定する
        // （プロジェクトのnowstreamingは「いずれかが配信中」のフラグなので、
        //  どの枠が配信中かはCrowdfunding_livesheduleの各ドキュメントのlive_statusで区別する）
        let liveStatus = data.live_status || "inprogress";

        // プロジェクトデータから不足している情報を補完
        const enrichedData = {
          ...data,
          live_status: liveStatus,
          event_id: projectId, // 遷移用にevent_idを設定
          isCrowdfunding: true, // 配信クラファンであることを示すフラグ
          projectid: projectId,
        };

        // プロジェクトデータから情報を補完
        if (projectData) {
          if (!enrichedData.eventtitle && projectData.projectTitle) {
            enrichedData.eventtitle = projectData.projectTitle;
          }
          if (!enrichedData.vendor_ja && projectData.vendor_ja) {
            enrichedData.vendor_ja = projectData.vendor_ja;
          }
          if (!enrichedData.vendor_image && projectData.vendor_image) {
            enrichedData.vendor_image = projectData.vendor_image;
          }
          if (!enrichedData.iconURL && projectData.iconURL) {
            enrichedData.iconURL = projectData.iconURL;
          }
        }

        return enrichedData;
      })
      .filter((item) => item.live_status !== "ended"); // 終了した配信は除外

    // 通常のライブデータと配信クラファンのライブデータを統合
    liveData.value = [...goodsLiveData, ...crowdfundingLiveData];
  } catch (error) {
    console.error("配信クラファンライブスケジュールの取得エラー:", error);
    liveData.value = goodsLiveData;
  }

  console.log(liveData);
};

// 関数を呼び出してデータを取得
getLiveData();

//配信クラファンデータ
const crowdfundingProjectsData = ref([]);
const getCrowdfundingProjectsData = async () => {
  try {
    // Crowdfunding_projects コレクションから全てのドキュメントを取得
    const q = query(collection(db, "Crowdfunding_projects"));

    // クエリに基づいてドキュメントを取得
    const querySnapshot = await getDocs(q);

    // 取得したドキュメントのデータをcrowdfundingProjectsDataに格納
    // ドキュメントIDをprojectidとして追加
    crowdfundingProjectsData.value = querySnapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        ...data,
        projectid: data.projectid || doc.id, // projectidが存在しない場合はドキュメントIDを使用
      };
    });
  } catch (error) {
    console.error("配信クラファンデータの取得エラー:", error);
  }
};

// この関数を呼び出してデータを取得
getCrowdfundingProjectsData();

// イベントデータと配信クラファンデータを統合
const allEventsData = computed(() => {
  // 配信クラファンデータをイベントデータ形式に変換
  const convertedCrowdfunding = crowdfundingProjectsData.value.map((project) => {
    return {
      ...project,
      // 既存のフィールドを保持しつつ、VendorPicturesで使用する形式に合わせる
      eventtitle: project.projectTitle,
      livenumber: project.vendor_ja,
      event_id: project.projectid, // 遷移用にevent_idも設定
    };
  });

  // 通常のイベントデータと統合
  return [...productsData.value, ...convertedCrowdfunding];
});
</script>

<template>
  <TheCarousel :productsData="allEventsData" />

  <!-- <div class="beginners-button-container">
    <BeginnersButton />
  </div> -->

  <!-- <div class="crowdfunding-button-container">
    <CrowdfundingButton />
  </div> -->

  <h2 class="title">配信</h2>
  <LiveSchedule :liveData="liveData" />
  <h2 class="title">イベント</h2>
  <VendorPictures :productsData="allEventsData" />
</template>

<style scoped>
.title {
  margin: 40px 0 40px 0px;
}

.beginners-button-container {
  margin: 40px 60px;
  display: flex;
  justify-content: center;
}

.crowdfunding-button-container {
  margin: 20px 60px;
  display: flex;
  justify-content: center;
}
</style>
